import React from 'react'
import interestsData from "../data/interests"

const Interests = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700 mb-7">
          {interestsData.headings.interests}
        </h1>
        <div className="my-10 sm:text-lg">
          <div className="">
            {interestsData.groups.map((group, idx) => (
              <div className="pl-2 py-2" key={idx}>
                <ul className="sm:flex sm:justify-evenly mt-3">
                  {group.map((item) => (
                    <div className="flex space-x-2 sm:space-x-4" key={item}>
                      <li>
                        <i className="fa-solid fa-circle text-xs"></i>
                      </li>
                      <li>{item}</li>
                    </div>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Interests
